// Query-параметр с Id исполнителя, услуги которого копируются в открытого исполнителя
export const COPYING_SERVICES_FROM_EMPLOYEE_PARAM = 'copyingServicesFrom';

// Состояние загрузки услуг в таблицу вкладки «Услуги»: isCopying — в таблицу
// загружаются (загружены) услуги другого исполнителя для копирования
export interface ServicesLoadState {
  status: 'loading' | 'success' | 'error';
  isCopying: boolean;
}
